import { render, staticRenderFns } from "./ArticleEdit.vue?vue&type=template&id=bd121bac"
import script from "./ArticleEdit.vue?vue&type=script&lang=js"
export * from "./ArticleEdit.vue?vue&type=script&lang=js"
import style0 from "./ArticleEdit.vue?vue&type=style&index=0&id=bd121bac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports